import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReadingMedium = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "view 1",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M20 16C20 13.7908 18.2092 12 16 12C13.7908 12 12 13.7908 12 16C12 18.2092 13.7908 20 16 20C18.2092 20 20 18.2092 20 16Z",
			stroke: "var(--stroke-0, #9565FD)",
			strokeWidth: 2
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M16.0001 6.66667C21.5758 6.66667 26.3521 12.0176 28.343 14.6163C28.9753 15.4417 28.9753 16.5583 28.343 17.3837C26.3521 19.9824 21.5758 25.3333 16.0001 25.3333C10.4244 25.3333 5.64807 19.9824 3.65721 17.3837C3.02485 16.5583 3.02486 15.4417 3.65721 14.6163C5.64807 12.0176 10.4244 6.66667 16.0001 6.66667Z",
			stroke: "var(--stroke-0, #9565FD)",
			strokeWidth: 2,
			strokeLinejoin: "round"
		})]
	})
});
export default SvgReadingMedium;
